<!--
 * @Description: 系统管理员详情
 * @Autor: lwq
 * @Date: 2020-07-15 10:42:39
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:29:26
 * @FilePath: \mrc-base-frontend\src\views\mrc_system_admin\detail\index copy.vue
--> 
<template>
  <div>
    <mrc_ess_iconGroup
      :is_disabled="disabled"
      :show_del="false"
      @handleReturn="handleReturn"
      @handleEdit="handleEdit"
    ></mrc_ess_iconGroup>
    <mrc_ess_tabs :items="items">
      <template v-slot:content-1>
        <base-info
          @success="success1"
          :disabled="disabled"
          :paramsData="params"
          @cancel="cancel1"
        ></base-info>
      </template>
      <template v-slot:content-2>
        <func-set
          @success="success2"
          :disabled="disabled"
          :propsParams="mrbase_sys_function_permission"
          @cancel="cancel1"
        ></func-set>
      </template>
    </mrc_ess_tabs>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import baseInfo from "../modules/baseInfo";
import funcSet from "../modules/funcSet";
import {
  mrc_admin_info,
  mrc_admin_update,
} from "@/service/api/mrc_system_admin";
export default {
  components: { baseInfo, funcSet },
  props: {},
  data() {
    return {
      items: [
        this.$t("label_The_general_information"),
        this.$t("label_permissions"),
      ],
      disabled: true,
      params: {},
      mrbase_sys_function_permission: [],
    };
  },
  validations: {},
  computed: {},
  created() {},
  watch: {},
  async mounted() {
    await this.national("mrbase_sys_users");
    this.$nextTick(async () => {
      const uuid = this.$route.params.uuid || this.$store.state.uuid;
      const name = this.$store.getters.subPage_name;
      this.params.uuid = uuid;
      await this.getInfo();
    });
  },

  methods: {
    async success1(val) {
      this.params = Object.assign({}, val);
      await this.update();
    },
    cancel1() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          this.disabled = !this.disabled;
          await this.getInfo();
        })
        .catch(() => {});
    },
    async success2(val) {
      this.mrbase_sys_function_permission = val;
      await this.update();
    },
    async update() {
      const obj = Object.assign({}, this.params, {
        mrbase_sys_function_permission: this.mrbase_sys_function_permission,
        org_level_uuid: this.$store.state.userData.org_level_uuid,
      });
      const res = await mrc_admin_update(obj);
      if (res.code == 200) {
        this.$Message({
          text: this.$t("message_The_operation_was_successful"),
        });
        this.$router.go(-1);
      }
    },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
    },
    async getInfo() {
      const res = await mrc_admin_info({
        uuid: this.params.uuid,
      });
      if (res.code == 200) {
        const {
          status,
          user_account,
          user_pwd,
          user_primary_email,
          clients_uuid,
          user_name,
          uuid,
        } = res.data;
        this.params = Object.assign(
          {},
          {
            status,
            user_account,
            user_pwd,
            user_primary_email,
            clients_uuid,
            user_name,
            uuid,
          }
        );
        this.mrbase_sys_function_permission =
          res.mrbase_sys_function_permission;
      }
    },
  },
};
</script>

<style scoped>
</style>
